import {FC} from 'react'
import {Link} from 'react-router-dom'
import type {GetReportList, ProcedureInfoProps} from './types'

// @ts-ignore
import ListGroup from 'jbc-front/components/ListGroup'
// @ts-ignore
import {HEALTH_AND_WELFARE_PENSION} from 'procedureStatuses/reportList/common'

export const getReportList: GetReportList = function* ({
  healthInsuranceType,
  healthInsuranceJoined,
  welfarePensionInsuranceJoined,
}) {
  if (healthInsuranceJoined || welfarePensionInsuranceJoined) {
    if (healthInsuranceType === 'kyokai' || healthInsuranceType === 'other') {
      yield {
        num: 'r507',
        title: '健康保険・厚生年金保険 育児休業等取得者申出書（新規・延長）/終了届',
        editable: true,
        type: HEALTH_AND_WELFARE_PENSION,
      }
    } else if (healthInsuranceType === 'its') {
      yield {
        num: 'r508',
        title: '健康保険・厚生年金保険 育児休業等取得者申出書（新規・延長）/終了届',
        editable: true,
        type: HEALTH_AND_WELFARE_PENSION,
      }
    }
  }
}

const ProcedureInfo: FC<ProcedureInfoProps> = ({procedureStatus}) => (
  <>
    <ListGroup>
      <ListGroup.Title>手続き情報</ListGroup.Title>
      <ListGroup.Item as={Link} to={`/procedure_statuses/${procedureStatus.id}/childcare_info`}>
        手続き情報編集
      </ListGroup.Item>
    </ListGroup>
    <ListGroup>
      <ListGroup.Title>添付ファイル</ListGroup.Title>
      <ListGroup.Item as={Link} to={`/procedure_statuses/${procedureStatus.id}/attachments`}>
        添付ファイルの確認・編集
      </ListGroup.Item>
    </ListGroup>
  </>
)

export default {getReportList, ProcedureInfo}
